<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="550" content-class="rounded-lg" scrollable @keydown.esc="dialog = false">
			<v-card>
				<v-card-title class="text-body-1 text-sm-h6">
					<span class="black--text text-uppercase font-weight-bold">Bukti Pembayaran</span>
					<v-spacer></v-spacer>
					<v-btn text small color="pink" class="mr-n4" @click="modalHide">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pb-0">
					<v-row align="center" justify="center">
						<v-col cols="12" class="pt-0">
							<div class="text-body-2 font-weight-bold pb-1">Bank Pembayaran</div>
							<v-autocomplete outlined :items="bankAccountList" class="rounded-lg text-body-2 width-0" color="primary" dense hide-details="auto" return-object v-model="selectedBank" @focus="() => responseError.bank_account_id=''" :error-messages="responseError.bank_account_id">
								<template v-slot:selection="{ item }">
									<v-col class="pa-0">
										<div class="d-md-flex justify-space-between">
											<img width="15%" :src="`/assets/bank/${item.bank_account_bank_name.toLowerCase()}.svg`">
											<div class="my-auto text-body-2">{{ item.bank_account_number }} {{ item.bank_account_name }}</div>
										</div>
									</v-col>
								</template>
								<template v-slot:item="{ item }">
									<v-col class="pa-0">
										<div class="d-md-flex">
											<img width="15%" :src="`/assets/bank/${item.bank_account_bank_name.toLowerCase()}.svg`">
											<div class="my-auto text-body-2 pl-2">{{ item.bank_account_number }} {{ item.bank_account_name }}</div>
										</div>
									</v-col>
								</template>
							</v-autocomplete>
						</v-col>
						<template v-if="is_top == '0'">
							<v-col cols="12" class="pt-0">
								<div class="text-body-2 font-weight-bold pb-1">Bank Pengirim</div>
								<v-autocomplete v-model="bank_from" outlined :items="listBank" class="rounded-lg text-body-2" color="primary" dense hide-details="auto" item-text="bank_name" item-value="bank_name" @focus="() => responseError.bank_name=''" :error-messages="responseError.bank_name">
								</v-autocomplete>
							</v-col>
							<v-col cols="12" class="pt-0">
								<div class="text-body-2 font-weight-bold pb-1">Nama Rekening Pengirim</div>
								<v-text-field v-model="sender_name" outlined class="rounded-lg text-body-2" placeholder="Isi Nama Lengkap" dense hide-details="auto" @focus="() => responseError.bank_account_name=''" :error-messages="responseError.bank_account_name"></v-text-field>
							</v-col>
							<v-col cols="12" class="pt-0">
								<div class="text-body-2 font-weight-bold pb-1">Nomor Rekening Pengirim</div>
								<v-text-field @keypress="onlyNumber" v-model="sender_number" outlined class="rounded-lg text-body-2" dense hide-details="auto" @focus="() => responseError.bank_account_number=''" :error-messages="responseError.bank_account_number"></v-text-field>
							</v-col>
							<v-col cols="12" class="pt-0">
								<div class="text-body-2 font-weight-bold pb-1">Jumlah Transfer</div>
								<v-currency-field v-model="sending_value" outlined class="rounded-lg text-body-2" dense hide-details="auto" prefix="Rp" @focus="() => responseError.transfer_value=''" :error-messages="responseError.transfer_value"></v-currency-field>
							</v-col>
						</template>
						<v-col cols="12" class="pt-2 pb-1">
							<v-row class="justify-center">
								<v-col cols="10" sm="6" class="pa-0">
									<v-img width="100%" :src="image ? image :'/assets/seller/default-toko.svg'"></v-img>
								</v-col>
								<span class="pa-2 text-center">Format gambar .jpg .jpeg .png dan ukuran minimum 300 x 300 px (Untuk gambar optimal gunakan minimum 700 x 700 px)</span>
							</v-row>
						</v-col>
						<v-col cols="12" class="pt-2">
							<v-file-input @change="handleFileUpload" v-show="false" accept="image/*" id="inputImage" truncate-length="50"></v-file-input>
							<v-btn outlined block color="primary" large class="text-capitalize font-weight-bold text-body-2 rounded-lg" @click="openUpload">
								<v-icon>mdi-plus</v-icon>
								<span class="pl-2">Upload Bukti Pembayaran</span>
							</v-btn>
						</v-col>
						<v-col cols="12" class="pt-2">
							<div class="text-body-2 font-weight-bold pb-1">Catatan <span class="red--text">*</span></div>
							<v-textarea v-model="note" outlined class="rounded-lg text-body-2" hide-details="auto" height="110" no-resize></v-textarea>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-col cols="12" class="text-center">
						<v-btn depressed color="primary" large class="text-capitalize font-weight-bold text-body-2 rounded-lg" @click="confirm">Konfirmasi</v-btn>
					</v-col>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex';

export default {
	data () {
		return {
			dialog: false,
			bank: [
			{ name: 'Bank BCA', norek: '456 789 1410', img: '/assets/bank/bca.svg' },
			],
			selectedBank: {},
			min_transfer: 0,
			formData: new FormData(),
			image: '',
			bank_from:'',
			sender_name: '',
			is_top:'0',
			sender_number: '',
			sending_value: '',
			note: '',
		}
	},
	computed: {
		...mapState('options', ['listBank', 'bankAccountList']),
		...mapState('transaction', ['responseError']),
	},
	methods: {
		hideDialog() {
			this.$emit('hideDialog')
		},
		modalShow(bank, min_transfer,is_top) {
			console.log(is_top)
			this.is_top = is_top
			this.sending_value = min_transfer
			this.dialog = true
			this.selectedBank = bank
			this.min_transfer = min_transfer
		},
		modalHide() {
			this.dialog = false
		},
		async confirm() {
      if(!this.note){
        this.$store.commit('makeAlert',{
          show:true,
          message:'Catatan Wajib diisi',
          type:'error'
        })
        return
      }
      if(!this.image){
        this.$store.commit('makeAlert',{
          show:true,
          message:'Bukti bayar wajib dilampirkan',
          type:'error'
        })
        return

      }
			if(this.is_top == '0'){
				await this.formData.append('bank_account_id', this.selectedBank.bank_account_id);
				// await this.formData.append('bank_branch', this.bank_from.);
				await this.formData.append('bank_account_name', this.sender_name);
				await this.formData.append('bank_account_number', this.sender_number);
				await this.formData.append('transfer_value', this.sending_value);
				await this.formData.append('bank_name', this.bank_from);
				await this.formData.append('note', this.note);
				await this.$emit('action', this.formData)
			}else{
				await this.formData.append('bank_id', this.selectedBank.bank_account_id);
				await this.formData.append('note', this.note);
				await this.$emit('action', this.formData)
			}
		},
		async openUpload() {
			const input = await document.getElementById('inputImage')
			input.click()
		},
		handleFileUpload(event) {
			this.formData.append('image', event);

			if (!event)
				return;

			this.createImage(event);
		},
		createImage(file) {
			var reader = new FileReader();

			reader.onload = (e) => {
				this.image = e.target.result;
			};
			reader.readAsDataURL(file);
		},
	},
};
</script>
